import { AxiosResponse } from 'axios';

import { baseListExportService, baseListService } from '@/services/baseService';
import { IBetApiListResponse, IBetFilters, IBetStatsApi } from '@/types';
import { IListParams } from '@/types/service';
import { AppError } from '@/errors/appError';
import { exportBets, loadBets } from '@/api/bet';
import { BetFactory } from '@/models/betFactory';
import { useBetStore } from '@/stores/bet';
import { useAppStore } from '@/stores/app';

export const betService = {
    async load(params: IListParams<IBetFilters>): Promise<AxiosResponse<IBetApiListResponse>> {
        const betStore = useBetStore();
        const appStore = useAppStore();

        appStore.loading = true;
        try {
            const response = await baseListService<IBetApiListResponse>(loadBets, params);
            betStore.items = response.data.rows.map((item) => BetFactory.createFromPageApi(item));
            betStore.total = response.data.total;
            this.betStatsConvert(response.data.stats);

            return response;
        } catch (e) {
            throw new AppError(`Unable load bet list, request error`, { cause: e });
        } finally {
            appStore.loading = false;
        }
    },

    betStatsConvert(stats: IBetStatsApi) {
        const betStore = useBetStore();
        betStore.stats.abnormalBetCount = stats.abnormal_bet_count;
        betStore.stats.balance = stats.balance;
        betStore.stats.rejectedBetCount = stats.rejected_bet_count;
        betStore.stats.settledBetCount = stats.settled_bet_count;
        betStore.stats.settledStakeSum = stats.settled_stake_sum;
        betStore.stats.totalBetCount = stats.total_bet_count;
        betStore.stats.totalStakeSum = stats.total_stake_sum;
        betStore.stats.totalValidStakeSum = stats.total_valid_stake_sum;
        betStore.stats.unsettledBetCount = stats.unsettled_bet_count;
        betStore.stats.unsettledStakeSum = stats.unsettled_stake_sum;
        betStore.stats.yield = stats.yield;
    },

    async exportFile(params: IListParams<IBetFilters>): Promise<AxiosResponse<Blob>> {
        const appStore = useAppStore();

        appStore.loading = true;
        try {
            return await baseListExportService(exportBets, params);
        } catch (e) {
            throw new AppError(`Unable export bet list, request error`, { cause: e });
        } finally {
            appStore.loading = false;
        }
    },
};
